module.exports = __webpack_public_path__ + "img/calendar-clock.2e104a04.svg";